import $ from 'jquery';
/// import Swiper JS
import Swiper from 'swiper/swiper-bundle';
import { debounce } from 'lodash';
// import Swiper styles

export default class MultyMDC {
  constructor({
    containerSelector = '.js-multy-mdc',
    paginationSelector = '.js-multy-mdc-pagination',
    nextBtnSelector = '.js-multy-mdc-next',
    prevBtnSelector = '.js-multy-mdc-prev',
    wrapperSelector = '.js-multy-mdc-wrapper',
  } = {}) {
    this.containerSelector = containerSelector;
    this.paginationSelector = paginationSelector;
    this.nextBtnSelector = nextBtnSelector;
    this.prevBtnSelector = prevBtnSelector;
    this.wrapperSelector = wrapperSelector;

    this.init();
  }

  init() {
    this.initialized = true;

    this.$container = $(this.containerSelector);

    if (!this.$container.length) {
      this.initialized = false;
      return;
    }

    this.swiper = new Swiper(this.containerSelector, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 8,
      breakpoints: {
        768: {
          spaceBetween: 12,
        },
        1024: {
          spaceBetween: 24,
        },
      },
      pagination: {
        el: this.paginationSelector,
      },
      navigation: {
        nextEl: this.nextBtnSelector,
        prevEl: this.prevBtnSelector,
      },
    });

    this.ajustNavigationButtonsHeight();

    $(window).on(
      'resize',
      debounce(() => this.ajustNavigationButtonsHeight(), 200),
    );
  }

  ajustNavigationButtonsHeight() {
    const wrapperHeight = $(this.wrapperSelector).outerHeight();
    const btnHeight = $(this.nextBtnSelector).outerHeight();
    const $cardslider = $(this.containerSelector);
    const theme = $cardslider.attr('data-theme');

    if (wrapperHeight !== btnHeight) {
      $(this.nextBtnSelector).css('height', wrapperHeight);
      $(this.prevBtnSelector).css('height', wrapperHeight);
    }

    if (theme !== 'dark' && $(window).width() >= 1024) {
      $cardslider.attr('data-theme', 'dark');
    } else if (theme === 'dark' && $(window).width() < 1024) {
      $cardslider.attr('data-theme', 'light');
    }
  }
}
